import { useState } from "react";
import { Check, Heart, HelpCircle, RefreshCw, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const REACTIONS = {
  love: { label: "Love it", icon: Heart, cls: "bg-rose-700 text-white" },
  approve: { label: "Approve", icon: Check, cls: "bg-emerald-800 text-white" },
  unsure: { label: "Not sure", icon: HelpCircle, cls: "bg-amber-600 text-white" },
  change: { label: "Change it", icon: RefreshCw, cls: "bg-stone-800 text-white" },
};

export function ReactionChips({ list }) {
  if (!list?.length) return null;
  const counts = list.reduce((m, r) => ({ ...m, [r.value]: (m[r.value] || 0) + 1 }), {});
  return (
    <div className="absolute -bottom-2 left-2 z-10 flex gap-1" data-testid="reaction-chips">
      {Object.entries(counts).map(([v, n]) => { const R = REACTIONS[v]; return <span key={v} title={`${n} × ${R.label}`} className={`flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[10px] shadow ${R.cls}`}><R.icon className="h-3 w-3" />{n > 1 ? n : ""}</span>; })}
    </div>
  );
}

export default function ReactionBar({ el, mine, onReact, onClear }) {
  const [note, setNote] = useState(mine?.note || "");
  const [pending, setPending] = useState(null);
  const label = el.data?.name || el.data?.title || el.data?.caption || el.type;
  const pick = (v) => { setPending(v); onReact(v, note); setPending(null); };
  return (
    <div className="rise absolute inset-x-4 bottom-4 z-20 rounded-2xl border bg-card/95 p-3 shadow-xl backdrop-blur" data-testid="reaction-bar">
      <div className="flex flex-wrap items-center gap-2">
        <p className="mr-2 min-w-0 truncate text-sm"><span className="text-muted-foreground">Your take on</span> <strong>{label}</strong></p>
        {Object.entries(REACTIONS).map(([v, R]) => (
          <Button key={v} size="sm" variant={mine?.value === v ? "default" : "outline"} className={`rounded-full ${mine?.value === v ? R.cls : ""}`} onClick={() => pick(v)} disabled={pending} data-testid={`react-${v}`}><R.icon className="mr-1.5 h-3.5 w-3.5" />{R.label}</Button>
        ))}
        <Input value={note} onChange={(e) => setNote(e.target.value)} onBlur={() => mine && note !== (mine.note || "") && onReact(mine.value, note)} placeholder="Add a note (optional)" className="h-8 min-w-[160px] flex-1" data-testid="reaction-note-input" />
        {mine && <Button size="icon" variant="ghost" aria-label="Clear reaction" onClick={onClear} data-testid="react-clear"><X className="h-4 w-4" /></Button>}
      </div>
    </div>
  );
}
